export type AturanIsian = (v: unknown) => true | string;

function kosong(v: unknown): boolean {
  return v === null || v === undefined || String(v).trim() === "";
}

export function rentang(min: number, max: number, satuan = ""): AturanIsian {
  return (v: unknown) => {
    if (kosong(v)) return true;
    const n = Number(v);
    if (isNaN(n)) return "Isi dengan angka";

    return (n >= min && n <= max) || `Rentang ${min}–${max}${satuan ? " " + satuan : ""}`;
  };
}

export function maksKarakter(maks: number): AturanIsian {
  return (v: unknown) => kosong(v) || String(v).trim().length <= maks || `Maksimal ${maks} karakter`;
}

export const ATURAN = {
  suhu: rentang(30, 45, "°C"),
  nadi: rentang(0, 300, "x/mnt"),
  respirasi: rentang(0, 100, "x/mnt"),
  beratBadan: rentang(1, 300, "kg"),
  misSkor: rentang(0, 30),
  sgaSkor: rentang(0, 100),
  durasiJam: rentang(0, 24, "jam"),
  aliran: rentang(0, 1000, "ml/mnt"),
  ufGoal: rentang(0, 10000, "ml"),
  heparin: rentang(0, 100000, "iu"),
  totalUf: rentang(0, 20000, "ml"),
  ufRate: rentang(0, 5000, "ml"),
  intake: rentang(0, 10000, "ml"),
  ufTercapai: rentang(0, 20000, "ml")
};
